import { render, staticRenderFns } from "./FormPreferences.vue?vue&type=template&id=080b9ad8&"
import script from "./FormPreferences.vue?vue&type=script&lang=js&"
export * from "./FormPreferences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports